export default __webpack_public_path__ + "static/media/PhoneIcon.b364813c.svg";